import React from 'react';
import { clearBrowserAuthSession } from '../../utils/sessionLogout';


class AppLogout extends React.Component {
  state = {
    timer: null,
  };

  stayLoggedIn = false;

  componentDidMount() {
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keydown', this.resetTimer);
    window.addEventListener('mousemove', this.resetTimer);
    this.createTimer();
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
    window.removeEventListener('click', this.resetTimer, false);
    window.removeEventListener('keydown', this.resetTimer, false);
    window.removeEventListener('mousemove', this.resetTimer, false);
  }

  resetTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.createTimer();
  };

  handleLogout = () => {
    this.props.updateUser({
      authorized: false,
    });
    if (!this.stayLoggedIn) {
      clearBrowserAuthSession();
    }
    this.props.history.replace('/login');
  };

  createTimer = () => {
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    const defaultTimeout = 1800000;
    const now = new Date().getTime();
    let timeout = defaultTimeout;

    if (tokenExpiration) {
      const expiration = parseInt(tokenExpiration, 10);
      timeout = expiration - now;
      this.stayLoggedIn = timeout > defaultTimeout;
      if (timeout <= 0) {
        this.handleLogout();
        return;
      }
    }

    this.timer = setTimeout(this.handleLogout, timeout);
  };

  render() {
    return this.props.children;
  }
}

export default AppLogout;
